module.exports = __webpack_public_path__ + "static/img/iPhoneDownload.81fec93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iPhoneDownload.png
// module id = u6wX
// module chunks = 1